import { Injectable,EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { throwError, Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { GlobalConstants } from './global-variables';
import { CountryData } from 'src/app/shared/interfaces';

@Injectable({
  providedIn: "root"
})
export class ApiService {


	constructor(
		private http: HttpClient,
		public GlobalConstants: GlobalConstants
	) {
		if (this.GlobalConstants.data.api_version == 'v2') {
			environment.corePath = environment.corePathV2;
		}
	}
	reloadTemplate = new EventEmitter<any>();
	getUser(userId) {
		return this.http.get<any>(environment.corePath + '/users/' + userId, {})
			.pipe(
				map(res => res || res),
				catchError(error => throwError(error))
			);
	}
	getUserDetails() {
		return this.http.get<any>(environment.corePath + '/user', {})
			.pipe(
				map(res => res || res),
				catchError(error => throwError(error))
			);
	}

	getAllCountries() {
		return this.http.get(environment.corePath + "/countries").pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		);
	}

	getAllLanguages() {
		return this.http.get(environment.corePath + "/languages").pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		);
	}

	getApplicableCountries() {
		return this.http.get(environment.offerPathV2 + "/countries").pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		);
	}
	getAllInternationalCountries() {
		return this.http.get(environment.offerPathV2 + "/international_offers/countries").pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		);
	}
	getAllCities(params) {
		return this.http.get(environment.corePath + "/cities", {
			params: params
		}).pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		);
	}
	getAllInternationalCities(params) {
		return this.http.get(environment.offerPathV2 + "/international_offers/cities", {
			params: params
		}).pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		);
	}
	getAllLocalities(params) {
		return this.http.get(environment.corePath + "/localities", {
			params: params
		}).pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		);
	}

	getCards(params = {}) {
		return this.http.get<any>(environment.corePath + '/user/user_cards', {
			params: params
		})
			.pipe(
				map(res => res || []),
				catchError(error => throwError(error))
			);
	}

	getCardsbyProject(params = {}) {
		return this.http.get<any>(environment.corePath + '/user/user_cards/eligible_by_project', {
			params: params
		})
			.pipe(
				map(res => res || []),
				catchError(error => throwError(error))
			);
	}
	fetchCards(params = {}) {
		return this.http.get<any>(environment.corePath + '/user/user_cards/fetch', {
			params: params
		})
			.pipe(
				map(res => res || []),
				catchError(error => throwError(error))
			);
	}

	getCardsWithPoints(params = {}) {
		return this.http.get<any>(environment.corePath + '/user_card', {
			params: params
		})
			.pipe(
				map(res => res || []),
				catchError(error => throwError(error))
			);
	}

	binValidation(bin) {
		return this.http.get<any>(environment.offerPathV2 + "/bins/card_details?bin=" + bin).pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		)
	}
	cardValidation(bin) {
		return this.http.post<any>(environment.corePath + "/bins/validate", {bin: bin}).pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		)
	}
	addCard(bin, bin_type, iFrameData?: any){
		let payload: any = {
			bin: bin, 
			bin_type : bin_type
		};
		if (iFrameData) {
			payload = {...payload, txn_id: iFrameData?.txn_id, iframe_token: iFrameData?.url?.split('=')[iFrameData?.url?.split('=')?.length - 1]}
		}
		return this.http.post<any>(environment.corePath + "/user/user_cards", payload).pipe(
		  map(res => res || []),
		  catchError(error => throwError(error))
		);
	}
	validateCard(bin, bin_type) {
		return this.http.post<any>(environment.corePath + "/user/user_cards/search",{bin:bin, bin_type:bin_type}).pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		);
	}

	getRedemptions(params = {offer: true, pagination: false, page: 1}) {
		let httpOptions = {};
		if(this.GlobalConstants.client !== 'smeoffers') {
			httpOptions = {
				headers: new HttpHeaders({
					'exclude_project_id': 'true'
				})
			}	
		}
		return this.http.get(
			environment.offerPathV2 + "/redemptions?offer=true&paginate=" + 
			params.pagination + "&page=" +params.page
			,httpOptions).pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		);
	}

	getClient(v2 = false) {
		var cpath = v2 == false ? environment.corePath : environment.corePathV2;
		return this.http.get(cpath + "/client").pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		);
	}

	getOffers(params, isNearBy?, isInternational?) {
		return this.http.get(environment.offerPathV2 + "/offers?elgble=true", {
			params: params
		}).pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		);
	}

	getCategories(params) {
		return this.http.get(environment.offerPathV2 + "/categories?elgble=true", {
			params: params
		}).pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		);
	}

	getCategoryDetails(params = {}) {
		return this.http.get(environment.offerPathV2 + "/category_details?elgble=true", {
			params
		}).pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		);
	}

	getCategoryDetail(id, params) {
		return this.http.get(environment.offerPathV2 + "/category_details/" + id + "?elgble=true", {
			params: params
		}).pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		);
	}

	getMerchants(params) {
		// params['per_page'] = 100;
		return this.http.get(environment.offerPathV2 + "/merchants?elgble=true", {
			params: params
		}).pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		);
	}
	searchMerchants(params) {
		// params['per_page'] = 100;

		return this.http.get(environment.offerPathV2 + "/merchants?elgble=true", {
			params: params
		}).pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		);
	}

	redeem(offer, params) {
		return this.http.post(environment.offerPathV2 + "/offers/" + offer.id + "/redeem?elgble=true", params).pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		);
	}

	redeemByBin(offer, bin) {
		return this.http.post(environment.offerPathV2 + "/offers/" + offer.id + "/redeem?elgble=true", { bin: bin }).pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		);
	}
	createTokenUser(token, uid?, client?,attr = 'token') {
		let params = {};
		if (token) params[attr] = token;
		if (uid) params['uid'] = uid;
		if (client) params['client'] = client;
		if (this.GlobalConstants.data.api_version == 'v1') {
			return this.http.post(environment.corePath + "/sessions/create_with_user", params).pipe(
				map(res => res || []),
				catchError(error => throwError(error))
			);
		}
		else {
			return this.http.post(environment.corePath + "/sessions", params).pipe(
				map(res => res || []),
				catchError(error => throwError(error))
			);
		}
	}

	checkCardEligibility(bin, bin_type, bundle_id) {
		return this.http.get(environment.offerPathV2 + "/bins/validate?bin=" + bin + "&bundle_id=" + bundle_id).pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		);
	}


	getBanners(params) {
		return this.http.get(environment.offerPathV2 + "/client_banners", params).pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		);
	}
	getTerms(id) {
		return this.http.get(environment.offerPathV2 + "/offers/" + id + '/terms').pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		);
	}




	checkPinCode(pin) {
		return this.http.get(`https://api.postalpincode.in/pincode/${pin}`).pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		);
  }
	checkCordinates(cordinates) {
		return this.http.get(`https://api.opencagedata.com/geocode/v1/json?q=${cordinates}&key=d73135d9826a49ef91a2bf334da1be37`).pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		);
  }
	getProjects() {
		const httpOptions = {
      headers: new HttpHeaders({
        'exclude_project_id': 'true'
      })
    }
		return this.http.get(`${environment.offerPathV2}/eligible_projects`,httpOptions).pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		);
  }
	getPaymentLink(params){
		return this.http.post<any>(environment.apiUrlPaV1 +'payments', params).pipe(
		  map(res => res || []),
		  catchError(error => throwError(error))
		);
	}
	updateUserCreds(params){
		return this.http.put(environment.corePathV2 + "/user",params).pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		);
	}
	confirmEmail(params){
		return this.http.put(environment.corePathV2 + "/user/verify_email",params).pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		);
	}
	resendEmail(){
		return this.http.post<any>(environment.corePathV2 +'/user/resend_email_verification', {}).pipe(
		  map(res => res || []),
		  catchError(error => throwError(error))
		);
	}
  addLocation(params) {
    return this.http.post<any>(environment.corePath + "/user/user_locations/log", params).pipe(
      map(res => res || []),
      catchError(error => throwError(error))
    );
  }
	getApplicableLocalities(id) {
		return this.http.get(environment.offerPathV2 + `/nearby_offers/localities?state_id=${id}`).pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		);
	}
	getApplicableCities() {
		return this.http.get(environment.offerPathV2 + "/nearby_offers/states").pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		);
	}

	getIpCountry(){
		return this.http.get(environment.corePath + "/ipdetails").pipe(
			map(res => res || []),
			catchError(error => throwError(error))
			);
	}

	resendVoucher(offer){
		return this.http.get(environment.offerPathV2 + "/offers/" + offer.id + "/resend_voucher", {}).pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		);
	}

	getIFrameToken() {
		return this.http.get(environment.corePath + "/vces/iframe_token").pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		);
	}

	getVisaTokenStatus(token: string) {
		return this.http.get(environment.corePath + "/vces/" + token + "/token_status").pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		);
	}
	
	getCountryData(): Observable<CountryData> {
		return this.http.get<CountryData>('https://api.country.is/').pipe(
		  map((res: CountryData) => res || { ip: '', country: '' }),
		  catchError((error) => {
			return throwError(() => error);
		  })
		);
	  }
}
